"use client";
import { useEffect, useState } from 'react';
import "./index.scss";
import { useLanguage } from "@/app/utils/LanguageContext";
import Footer from "@/app/ui/footer";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";

import dayJS, { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import _, { forEach } from 'lodash';
import moment from "moment";
import { getAssetPrefix } from "@/app/utils/Common";
import NoInformation from "../Common/NoInformation";
import { getSearchParams, adobeData, getDayDisplay, getDBLPoolNo, updateMetaTag } from "@/app/utils/Common";
import Remarks from "@/app/ui/Common/remarks";
import { getSummaryInfo, getBusinessDate, getGoingReport } from "@/app/utils/request/requestList";
import { pageSet } from "@/app/utils/pageSet";
import dayjs from "dayjs";


const initSummaryInfo = {
  // --MeetingInfos--
  RaceSeason: "26/27",
  MeetingDate: "2023-10-11",
  Venue: "HV",
  Racecourse: "Happy Valley",
  NoOfRace: 8,
  StartTime: "2023-10-11T12:00:00",
  IsLocal: true,
  //--MeetingInfos--

  // --GoingInfo--
  CourseInfo: [
  {
  Track: "TURF",
  Course: "A COURSE",
  Code: "A"
  }
  ],
  GoingDetail: [
    // {
    //   Track: "TURF",
    //   Going: "GOOD",
    //   Races: "1,3,5,6,7,8,9,10"
    // },
    // {
    //   Track: "AWT",
    //     Going: "SEALED",
    //     Races: "2,4"
    //   }
  ],
  HasStewards: false,
  ChairmanList: [],
  ChiefList: [],
  StewardList: [],
  Penetrometers: [{
    Reading: 2.2,
    UpdatedTime: "2023-11-17T13:00:00"
  },{
    Reading: 3.2,
    UpdatedTime: "2023-11-17T15:00:00"
  },{
    Reading: 2.2,
    UpdatedTime: "2023-11-17T17:00:00"
  }],
  Hammers:  [{
    Reading: 2.2,
    UpdatedTime: "2023-11-17T13:00:00"
  },{
    Reading: 3.2,
    UpdatedTime: "2023-11-17T15:00:00"
  },{
    Reading: 2.2,
    UpdatedTime: "2023-11-17T17:00:00"
  }],
  RaceDate: "2023-10-11",
  Track: "TURF",
  // --GoingInfo--

  // BettingPools: [], 
  LocalPool: [], 
  BettingPoolOver: [], 
  // {
  //   GeneralPoolList: [],
  //   AllUpPoolList: [],
  //   FixedOdds: [],
  //   DoublePoolList: [],
  //   EstDividendList: null,
  //   OBComminglePoolList: [],
  //   CFJackpots: [],
  //   IsLocal: true,
  //   Venue: "HV",
  //   Racecourse: "Happy Valley"
  // },
  Stewards: [],
  ResumedJockeys: [],
  SuspendedJockeys: [],
  DeferredSuspensionJockey: []
}

function toPascalCaseWithSpaces(str:any) {
    return str
        ?.split(" ")
        ?.map((word:any) => {
            if (!(/^[a-zA-Z]$/.test(word?.charAt?.(0)))) return word;
            return word?.charAt?.(0)?.toUpperCase?.() + word?.slice?.(1)?.toLowerCase?.();
        })
        ?.join(' ').replaceAll("\"", "")
}
const formatTime = (dateString:any) => {
   const date = new Date(dateString);
   let hours = date.getHours();
   const minutes = date.getMinutes();

   const ampm = hours >= 12 ? 'pm' : 'am';

   hours = hours % 12;
   hours = hours ? hours : 12; 

   const minutesStr = minutes < 10 ? '0' + minutes : minutes;
   const hoursStr = hours < 10 ? '0' + hours : hours;

   return `${hoursStr}:${minutesStr} ${ampm}`;
}
const capitalizeWords = (str: any) => {
  return str?.split(' ')
      ?.map((word:any) => word?.charAt?.(0)?.toUpperCase?.() + word?.slice?.(1)?.toLowerCase?.())
      ?.join(' ');
}
const Summary: React.FC = () => {

  const { state: lang } = useLanguage();

  const [summaryInfo, setSummaryInfo] = useState<any>(initSummaryInfo);
  const assetPrefix = getAssetPrefix();

  const { t, langCode } = lang;
  const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));

  // let hasData = 1; //1: hasData, 2: noinfo, 3: willbeavailable -> test UI

  const [raceDate, setraceDate] = useState("");
  const [hasData, sethasData] = useState(1);
  const [bizdate, setbizdate] = useState("");
  const [loading, setloading ] = useState(true);
  const [GoingReport, setGoingReport ] = useState("");
  
  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  useEffect(() => {
    // getBusinessDate().then((res:any) => {
    //   const resbizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));
     
    //   console.log(resbizdate,"resbizdate------------")
    //   if (regex.test(racedate) && dayjs(racedate).isBefore(resbizdate)) {
    //     setloading(false);
    //   } else {
    //     setbizdate(resbizdate);
    //   }
    // })
    updateMetaTag(lang.langCode, pageSet.summary);
    adobeData(lang.langCode, "pageview", {
      pageId: "racing/local",
    });
  }, [])
  useEffect(() => {
    if (!raceDate) return
    getGoingReport(lang.langCode).then((res:any) => {
      if (dayjs(res?.item?.reportDate?.date, 'DD-MM-YYYY').format("YYYY-MM-DD") == raceDate && res?.item?.rollTrack?.value) {
        setGoingReport(res?.item?.rollTrack?.value);
      }
    });
  }, [raceDate])
  //get QIDS Data
  useEffect(() => {
    // if (!bizdate) return
    getSummaryInfo("")
      .then((res:any) => {
        if(!res)
        {
          sethasData(2);
          setloading(false);
          return;
        } 
        const notReadyStatus = ["ENTRY", "DRAFT",'INITIAL', 'ENTRY_ABANDON'];
        const commonMeetingsList = res?.commonMeetings?.filter((i:any) => !notReadyStatus.includes(i?.status) && i?.venueCode != "CH") || [];
        const LocalVenuCode = ["ST", "HV"];
        const LocalMeeting = commonMeetingsList?.filter((i:any) => LocalVenuCode.includes(i?.venueCode) && i?.pmPools?.length > 0) || [];
        // no LocalMeeting
        // debugger
        if(!LocalMeeting?.length) {
          if ((racedate && regex.test(racedate))){
            setloading(false);
            sethasData(3);
            return 
          } 
          
          const overseasMeeting = res?.commonMeetings?.find((i:any) => !LocalVenuCode.concat('CH').includes(i?.venueCode));
          if(overseasMeeting){
            const date = overseasMeeting?.date?.replaceAll("-", "");
            const venueCode = overseasMeeting?.venueCode;
            window.location.href = `/racing/overseas/${lang?.langType}/summary.aspx?para=/${date}/${venueCode}`
            return 
          }else {
            setloading(false);
            sethasData(3);
            return 
          }
        }
        const BetTypesOrder = ['WIN', 'PLA', 'QIN', 'QPL', 'FCT', 'TCE', 'TRI', 'FF', 'QTT', 'TBL', 'DT', 'TT', 'SixUP'];
        const AllUpBetTypesOrder = ['WIN', 'PLA', 'QIN', 'QPL', 'FCT', 'TRI'];
        const JackPotPoolOrder = ['WIN', 'PLA','TT', 'SixUP', 'DT'];
        // venueCode
        const BetTypes = ["WIN","PLA","QIN","QPL","CWA","CWB","CWC","IWN","FCT","TCE","TRI","FF","QTT","DBL","TBL","DT","TT","SixUP"];
        const AllUpBetTypes = ["WIN","PLA","QIN","QPL","CWA","TRI","FCT"];

        const CmbBetTypes = ["TT","SixUP","DT","TCE+TRI", "QTT+FF"]; // mergedPoolId
        const mergedPoolIdList = ["TCE", "TRI", "QTT", "FF"];
        const validStatus = ['DECLARED', 'DEFINED', 'STARTED', 'CLOSED', 'ABANDON', 'ABANDON_PARTIAL'];
        const CommingleType = ["WIN", "PLA"];
        const BettingPools = commonMeetingsList?.map((com:any) => {
          const noOfRace = com?.totalNumberOfRace || "";
          const IsLocal = LocalVenuCode.includes(com?.venueCode);
          const isOBCommingle = !IsLocal && com?.pmPools?.filter((i:any) => BetTypes.includes(i?.oddsType) && i?.comingleStatus > 0).length > 0;
          let genPoolList  = [] as any;
          const tempgenPoolList = com?.pmPools?.filter((pmp:any) => pmp?.oddsType != "DBL")?.map((gen:any) => {

            let oddsType_CH = "";
            switch (gen?.oddsType) {
              case 'FF':
                oddsType_CH = 'F-F';
                break;
              case 'DT':
                oddsType_CH = 'D-T';
                break;
              case 'SixUP':
                oddsType_CH = '6UP';
                break;
                case 'TT':
              oddsType_CH = 'T-T';
                break;
              default:
                oddsType_CH = gen?.oddsType;
                break;
            }

            return {
              PoolName: t(`LB_${gen?.oddsType}`).toUpperCase() + (lang.langCode != "en-us" ? ` (${oddsType_CH})`:""),
              BetType: gen?.oddsType,
              Legs: [{
                number : gen?.leg?.number,
                races: gen?.leg?.races?.join?.(","),
                racesNo: gen?.leg?.races?.[0] || 0
              }],
              All: false
            }
          })
          
          tempgenPoolList.forEach((tp:any) => {
            const curItem = genPoolList?.find((gp:any) => gp?.BetType == tp?.BetType);
            if (curItem) {
              curItem.Legs = curItem?.Legs.concat(tp?.Legs);
            } else {
              genPoolList.push(tp)
            }
          })
          genPoolList = genPoolList?.map((item:any) => {
            let displayLegs = "";
            const sortLegs = item?.Legs?.sort((a:any, b:any) => {
              if(a?.number != -1 && b?.number != -1) return a?.number - b?.number
              return a?.racesNo - b?.racesNo
            });
            switch (item?.BetType) {
              case "TBL":
              case "SixUP": 
              case "DT":
                if (item?.Legs?.length > 1) {
                  displayLegs = sortLegs.map((i:any) => t(`LB_${item?.BetType}PoolName`).replace("{0}", getDBLPoolNo(i?.number, lang.langCode)).replace("{1}", i?.races)).join("<br>")
                } else {
                  displayLegs = t("LB_Race").replace("{0}", sortLegs?.map((i:any)=> i?.races).join(","))
                }
                break;
                
              default:
                displayLegs = item?.Legs?.length == noOfRace ? t("LB_AllRaces") : t("LB_Race").replace("{0}", sortLegs?.map((i:any)=> i?.races).join(","))
                break;
            }
            return {
              ...item,
              displayLegs,
              All: item?.Legs?.length == noOfRace,
            }
          }).sort((a:any, b:any) => {
              return BetTypesOrder.indexOf(a.BetType) - BetTypesOrder.indexOf(b.BetType);
          });

          const DBLPoolList = com?.pmPools?.filter((pmp:any) => pmp?.oddsType == "DBL") || [];

          const allUpPoolList = noOfRace > 1 ? genPoolList.filter((i:any) => AllUpBetTypes.includes(i?.BetType)).map((ap:any) => {
            return {
              ...ap,
              displayLegs: ap?.All ? t("LB_Race").replace("{0}", t("LB_AllRaces")) : ap?.displayLegs,
              PoolName: t(`LB_ALLUP${ap?.BetType}`)
            }
          }).sort((a:any, b:any) => {
              return AllUpBetTypesOrder.indexOf(a.BetType) - AllUpBetTypesOrder.indexOf(b.BetType);
          }) : []

          const futureJackpot = com?.pmPools
          ?.filter((i:any) => {
            const hasCurVenCode = i?.futureJackpot?.find((ii:any) => ii?.venCode && LocalVenuCode?.includes(ii?.venCode) == LocalVenuCode?.includes(com?.venueCode));
            return i?.futureJackpot?.length && Boolean(hasCurVenCode);
          }).reduce((acc:any, current:any) => {
            const x = acc.find((item :any) => item.oddsType === current.oddsType);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
          }, [])
          ?.map((pm: any) => {
            let tempPName = t(`LB_${pm?.oddsType}`).toUpperCase();
              if(["WIN", "PLA"].includes(pm?.oddsType)) {
                tempPName = t(`LB_${pm?.oddsType}`).toUpperCase() + `${lang.langCode == "en-us"? "<br/>": " "}` + t("LB_JackPotPoolName").replace("{0}", pm?.leg?.number)
              } else if (["DT","DBL", "TBL"].includes(pm?.oddsType)) {
                // t("LB_Number").replace("{0}",getDBLPoolNo(pm?.leg?.number, lang.langCode)) + " " + 
                tempPName = t(`LB_${pm?.oddsType}`)?.toUpperCase();
              } else if (["SixUP"].includes(pm?.oddsType)) {
                tempPName = t("LB_6UP_WIN_BONUS")?.toUpperCase();
              }
              tempPName = tempPName + `${lang.langCode == "en-us" ? " "+ t("LB_CFJackPot"): t("LB_CFJackPot")}`;

            // let cfdate = pm?.futureJackpot?.meetingDate?.substring(0, pm?.futureJackpot?.meetingDate?.indexOf('+'));
            const temp_futureJackpot = pm?.futureJackpot
            ?.filter((i:any) => LocalVenuCode?.includes(i?.venCode) == LocalVenuCode?.includes(com?.venueCode))
            ?.map((i:any) => ({
              CFDate: i?.meetingDate?.substring(0, i?.meetingDate?.indexOf('+')),
              Jackpot: new Intl.NumberFormat('en-US').format(i?.jackpot)
            }));
            return {
              // Jackpot: temp_futureJackpot?.map((i:any) => `$${new Intl.NumberFormat('en-US').format(i?.jackpot)}`),
              // CFDates : Array.from(new Set(temp_futureJackpot?.map((i:any) => i?.meetingDate?.substring(0, i?.meetingDate?.indexOf('+'))) || [])),
              temp_futureJackpot,
              PoolName : tempPName,
              BetType: pm?.oddsType,
            }
          }) || [];
          const futureJackpot_temp = [] as any;
          
          futureJackpot?.forEach((item:any) => {
            if (item?.temp_futureJackpot?.length) {
              const res = _.groupBy(item?.temp_futureJackpot, "CFDate") || [] as any;
              Object.keys(res).map((key:any) => {
                  futureJackpot_temp.push({
                    Jackpot: res[key]?.map((i:any) => i.Jackpot),
                    CFDate: key,
                    PoolName: item?.PoolName,
                    BetType: item?.BetType,
                  })
              })
            }
          });
          // console.log('futureJackpot------', futureJackpot, com?.venueCode)
          const headTitleCountry = com?.country?.sort((a:any,b:any) => a?.seq - b?.seq)?.map((i:any) => lang.langCode == "en-us" ? i?.nameen : i?.namech).join("/")
          const disNil = lang.langCode == "en-us" ? "Nil": "無";
          const tempEstDividendList = com?.pmPools?.filter((i:any) => i?.jackpot != null || i?.estimatedDividend > 0);
          const mergedPoolGroup =  _.groupBy(tempEstDividendList?.filter((i:any) => !!i?.mergedPoolId), "mergedPoolId");
          const mergedPoolkeyMap = Object.keys(mergedPoolGroup);
          const mergedPool = [] as any;
          if(mergedPoolkeyMap.length) {
            mergedPoolkeyMap.forEach((key:any) => {
              const mergedPoolItem = mergedPoolGroup[key];
              const mergeBetType = mergedPoolItem.map((i:any) => i?.oddsType).join("+");
              const mergePoolName = t(`LB_${mergeBetType}`)?.toUpperCase();
              const mergeJackpot = parseInt(mergedPoolItem?.find((i:any) => i?.jackpot > 0)?.jackpot || 0);
              // const mergeJackpot = mergedPoolItem.map((i:any) => parseInt(i?.jackpot || 0)).reduce((acc:any, curr:any) => acc + curr, 0);  
              const mergeDividend = mergedPoolItem.map((i:any) => parseInt(i?.estimatedDividend || 0)).reduce((acc:any, curr:any) => acc + curr, 0);  
              const mergelegNumber =  mergedPoolItem?.[0]?.leg?.number;
              const mergelegRacaNo =  mergedPoolItem?.[0]?.leg?.races?.[0];
              mergedPool.push({
                BetType: mergeBetType,
                PoolName: mergePoolName + `${lang.langCode == "en-us"? "<br/>": " "}` + t("LB_JackPotPoolName").replace("{0}", mergelegNumber),
                Jackpot: mergeJackpot <= 0 ? disNil : `$${new Intl.NumberFormat('en-US').format(mergeJackpot)}`,
                Dividend: mergeDividend <= 0 ? "" :  `$${new Intl.NumberFormat('en-US').format(mergeDividend)}`,
                RaceNo: mergelegRacaNo,
                legNumber :mergelegNumber
              })
            })
          }
          // console.log('mergedPool-----', mergedPool)
          // console.log('mergedPoolGroup-----', mergedPoolGroup)
          return {
            GeneralPoolList: genPoolList,
            AllUpPoolList: allUpPoolList,
            FixedOdds: com?.foPools?.sort((a:any, b:any) => {
              const typeOrder = a.oddsType === "JKC" ? -1 : 1;
              const typeOrderB = b.oddsType === "JKC" ? -1 : 1;
          
              if (typeOrder !== typeOrderB) {
                  return typeOrder - typeOrderB;
              }
              return parseInt(a.instNo) - parseInt(b.instNo);
              })?.map((fop:any) => {
              return lang.langCode == "en-us" ? fop?.oddsTypeDes?.english.replace("{0}", fop?.instNo) : fop?.oddsTypeDes?.chinese.replace("{0}", fop?.instNo)
            }),
            DoublePoolList: DBLPoolList?.sort((a:any, b:any) => {

              if (a?.leg?.number != -1 && b?.leg?.number != -1) return a?.leg?.number - b?.leg?.number;
              return a?.leg?.races?.[0] - b?.leg?.races?.[0]
            })?.map((dbl:any) => {
              return {
                PoolName:  DBLPoolList?.length == 1 ? t("LB_DBLPoolName_0").replace("{0}", dbl?.leg?.races?.join?.(",")) : t("LB_DBLPoolName").replace("{0}", getDBLPoolNo(dbl?.leg?.number, lang.langCode)).replace("{1}", dbl?.leg?.races?.join?.(",")),
                BetType: dbl?.oddsType,
                Legs: dbl?.leg?.races?.join?.(","),
                All: false
              }
            }),
            EstDividendList: tempEstDividendList?.map((est:any) => {
              const oTypeNum = com?.pmPools?.filter((i:any) => est?.oddsType == i?.oddsType);

              let tempPName = t(`LB_${est?.oddsType}`).toUpperCase();
              if(["WIN", "PLA"].includes(est?.oddsType)) {
                tempPName = t(`LB_${est?.oddsType}`).toUpperCase() + `${lang.langCode == "en-us"? "<br/>": " "}` + t("LB_JackPotPoolName").replace("{0}", est?.leg?.number)
              } else if (["DT", "TT", "DBL", "TBL"].includes(est?.oddsType)) {
                tempPName = oTypeNum.length > 1 ? t("LB_Number").replace("{0}",getDBLPoolNo(est?.leg?.number, lang.langCode)) + " " + t(`LB_${est?.oddsType}`)?.toUpperCase() : t(`LB_${est?.oddsType}`)?.toUpperCase();
              } else if (["SixUP"].includes(est?.oddsType)) {
                tempPName = `${oTypeNum.length > 1 ? t("LB_Number").replace("{0}",getDBLPoolNo(est?.leg?.number, lang.langCode)) + " ": ""}` + t("LB_6UP_WIN_BONUS")?.toUpperCase();
              } else if (mergedPoolIdList.includes(est?.oddsType) && est?.mergedPoolId) {
                return null
              }

              const disJockpot = `$${new Intl.NumberFormat('en-US').format(est?.jackpot)}`;
              const Jackpot = IsLocal ? (est?.jackpot <= 0 ? disNil : disJockpot) : (est?.jackpot <= 0 ? (CommingleType.includes(est?.oddsType) ? "$0" : disNil) : disJockpot)
              return {
                BetType: est?.oddsType,
                PoolName: tempPName,
                Jackpot,
                Dividend: est.estimatedDividend <= 0 ? disNil : `$${new Intl.NumberFormat('en-US').format(est?.estimatedDividend)}`,
                RaceNo: CmbBetTypes.includes(est?.oddsType) ? 0 : est?.leg?.races?.[0],
                legNumber : !CmbBetTypes.includes(est?.oddsType) ? 0 : est?.leg?.number
              }
            })?.filter((i:any) => i != null)?.concat(mergedPool)?.sort((a:any, b:any) => {
              const IndexA = JackPotPoolOrder.indexOf(a.BetType);
              const IndexB = JackPotPoolOrder.indexOf(b.BetType);
              if (IndexA !== IndexB) return IndexA - IndexB;
              if (a.legNumber != b.legNumber) {
                return a.legNumber - b.legNumber;
              }
              return a.RaceNo - b.RaceNo;
            }),
            isOBCommingle,
            CFJackpots: _.groupBy(futureJackpot_temp, "CFDate"),
            // CFJackpots: [],
            IsLocal: IsLocal,
            Venue: com?.venueCode,
            Course: lang.langCode == "en-us" ? toPascalCaseWithSpaces(com?.course?.english) : com?.course?.chinese.replaceAll("\"", "\'"),
            // Course: com?.course?.code || "",
            Country:  lang.langCode == "en-us" ? `(${com?.venueCode} ${com?.country?.[0]?.nameen || ""})`  : `(${com?.venueCode} ${com?.country?.[0]?.namech || ""})`,
            Country_Title: `${t(com?.venueCode)} ${headTitleCountry}`,
            Track: lang.langCode == "en-us" ? com?.meetingTrack_en : com?.meetingTrack_ch,
            TrackCode: com?.meetingTrackCode,
            ...com
          }
        })
        let LocalPool = BettingPools?.filter((i:any) => i?.IsLocal && validStatus.includes(i?.status));
        let BettingPoolOver = BettingPools?.filter((i:any) => !i?.IsLocal);

        const headDate = [] as any;
        BettingPools?.sort((a:any, b:any) => {
          return (new Date(a?.date) as unknown as number) - (new Date(b?.date) as unknown as number); 
        }).forEach((ele: any) => {
          const tempDate = headDate?.find((d:any) => d?.date == ele?.date);
          if (tempDate) {
            tempDate.country = tempDate.country + " / " + ele?.Country_Title;
          } else {
            headDate.push({
              date: ele?.date,
              country: ele?.Country_Title,
              IsLocal: ele?.IsLocal,
              venueCode: ele?.venueCode
            })
          }
        });
        let jkSuspensions = [] as any;
        let StartTime = "";
        let RaceDate = "";
        let NoOfRace = "";
        let VenueCode = "";
        let stewardsTemp = [] as any;
        let Penetrometers = [] as any;
        let Hammers = [] as any
        let targetMeeting = LocalPool?.find((i:any) => i?.date == racedate?.replaceAll("/", "-"));

        if (racedate && regex.test(racedate) && LocalPool?.length) {
          if (!targetMeeting) {
            setloading(false);
            sethasData(3);
            return 
          } else {
            jkSuspensions = targetMeeting?.jkSuspensions || []
            stewardsTemp = targetMeeting?.stewards || [];
            RaceDate = targetMeeting?.date || "";
            StartTime = targetMeeting?.startTime || "";
            NoOfRace = targetMeeting?.totalNumberOfRace || "";
            VenueCode = targetMeeting?.venueCode || "";
            Penetrometers = targetMeeting?.penetrometerReadings || [];
            Hammers = targetMeeting?.hammerReadings || [];
            setraceDate(targetMeeting?.date);
          }
        } else {
          jkSuspensions = LocalPool[0]?.jkSuspensions || []
          stewardsTemp = LocalPool[0]?.stewards || [];
          RaceDate = LocalPool[0]?.date || "";
          StartTime = LocalPool[0]?.startTime || "";
          NoOfRace = LocalPool[0]?.totalNumberOfRace || "";
          VenueCode = LocalPool[0]?.venueCode || "";
          Penetrometers = LocalPool[0]?.penetrometerReadings || [];
          Hammers = LocalPool[0]?.hammerReadings || [];
          setraceDate(LocalPool?.[0]?.date);
        }

        LocalPool = LocalPool?.filter((i:any) => i?.date == RaceDate);
        BettingPoolOver = BettingPoolOver?.filter((i:any) => i?.date == RaceDate);

        if (Penetrometers?.length) {
          Penetrometers.sort((a:any, b:any) => {
            return (new Date(a?.readingTime) as unknown as number) - (new Date(b?.readingTime) as unknown as number); 
        });
        }
        if (Hammers?.length) {
          Hammers.sort((a:any, b:any) => {
            return (new Date(a?.readingTime) as unknown as number) - (new Date(b?.readingTime) as unknown as number); 
        });
        }

        const MapSuspendedJockeys = (data: any) => {
          const temp = data?.map((i:any) => ({...i, commencedOn: i?.commencedOn?.substring(0, i?.commencedOn?.indexOf('+')), resumedOn: i?.resumedOn?.substring(0, i?.resumedOn?.indexOf('+'))}))?.sort((a:any, b:any) =>
          (new Date(a?.commencedOn) as unknown as number) - (new Date(b?.commencedOn) as unknown as number))
              console.log('temp------', JSON.parse(JSON.stringify(temp)));
          const newTemp = [] as any;
          for (let index = 0; index < temp.length; index++) {
            let MergedRecords = [] as any;
            const cur = temp[index];
            
            let offset = index + 1;
            while (true) {
              if (offset == temp.length) break;
              const curoffset = temp[offset - 1];
              const next = temp[offset];
              if (curoffset.resumedOn != next.commencedOn) break;

              if (!MergedRecords.length && cur.resumedOn == next.commencedOn) {
                MergedRecords.push({
                  resumedOn: curoffset.resumedOn,
                  commencedOn: curoffset.commencedOn,
                  desc: lang.langType === "english" ? curoffset?.desc?.english : curoffset?.desc?.chinese,
                })
                MergedRecords.push({
                  resumedOn: next.resumedOn,
                  commencedOn: next.commencedOn,
                  desc: lang.langType === "english" ? curoffset?.desc?.english : curoffset?.desc?.chinese,
                })
                offset++;
              } else if(curoffset.resumedOn == next.commencedOn){
                 MergedRecords.push({
                  resumedOn: next.resumedOn,
                  commencedOn: next.commencedOn,
                  desc: lang.langType === "english" ? curoffset?.desc?.english : curoffset?.desc?.chinese,
                })
                offset++;
              } else {
                break;
              }
            }

            if (MergedRecords?.length) {
              MergedRecords?.sort((a:any, b:any) =>
              (new Date(a?.commencedOn) as unknown as number) - (new Date(b?.commencedOn) as unknown as number))
              const _commencedOn = MergedRecords[0].commencedOn;
              const _resumedOn = MergedRecords[MergedRecords?.length - 1].resumedOn;
              newTemp.push({
                jockeyId: cur?.jockeyId,
                mergedRecords: MergedRecords,
                commencedOn : _commencedOn,
                resumedOn: _resumedOn,
                jockeyNms : cur?.jockeyNms,
                spsnTyp: dayjs(_commencedOn).isAfter(dayjs(RaceDate)) ? "Deferred" :
                dayjs(_resumedOn).isBefore(dayjs(RaceDate)) || dayjs(_resumedOn).isSame(dayjs(RaceDate)) ? "Resumed"
                 : "Current"
              });

              index = offset - 1;
            } else {
              newTemp.push(cur)
            }

          }
          return newTemp
        }
        const tempjkSuspensions = _.groupBy(jkSuspensions, "jockeyId");
        let resjkSuspensions = [] as any;
        for (const key in tempjkSuspensions) {
          tempjkSuspensions[key] = MapSuspendedJockeys(tempjkSuspensions[key]);
           resjkSuspensions = [...resjkSuspensions, ...tempjkSuspensions[key]];
        }
        
        // console.log(`tempjkSuspensions: after`, JSON.parse(JSON.stringify(resjkSuspensions)), JSON.parse(JSON.stringify(tempjkSuspensions)));
        const ResumedJockeys = getfilterjkSuspensions(resjkSuspensions, "Resumed");
        const SuspendedJockeys = getfilterjkSuspensions(resjkSuspensions,  "Current");
        const DeferredSuspensionJockey = getfilterjkSuspensions(resjkSuspensions,  "Deferred"); 

        const ChairmanList = getfilterstewards(stewardsTemp, ["Chairman", "Racing Steward"]);
        const ChiefList = getfilterstewards(stewardsTemp, ["Chief Stipendiary Steward", "Acting Chief Stipendiary Steward"]);
        const StewardList = getfilterstewards(stewardsTemp, ["Stipendiary Steward"]);
        
        let GoingDetail = [] as any;
        if (LocalPool?.[0]?.races?.length) {
          const temp = LocalPool?.[0]?.races?.filter((i:any) => i?.goCode)?.map((ele:any) => {
            return {
              no: ele?.no,
              raceTrack: lang.langCode == "en-us" ? ele?.raceTrack?.description_en: ele?.raceTrack?.description_ch,
              go: lang.langCode == "en-us" ? ele?.go_en: ele?.go_ch,
              trackCode: ele?.raceTrack?.code,
              goCode: ele?.goCode
            }
          });
          temp?.forEach((ele2: any) => {
            const targetItem = GoingDetail?.find((i:any) => i?.trackCode == ele2?.trackCode);
            if (targetItem) {
              const tarRaceInfo = targetItem.RaceInfo.find((i:any) =>i?.goCode == ele2?.goCode);
              if(tarRaceInfo) {
                tarRaceInfo.Races.push(ele2?.no);
              } else {
                targetItem.RaceInfo.push({
                  goCode: ele2?.goCode,
                  Going  : ele2?.go,
                  Races  : [ele2?.no],
                })
              }
            } else {
              // let strTem = ele2?.trackCode == "AWT" ? (lang.langCode == "en-us" ? )
              let strTrack = "";
              switch (ele2?.trackCode) {
                case "AWT":
                  strTrack = lang.langCode == "en-us" ? "AWT" : "全天候";
                  break;
              
                default:
                  strTrack = lang.langCode == "en-us"? capitalizeWords(ele2?.raceTrack) : ele2?.raceTrack;
                  break;
              }
              GoingDetail.push({
                trackCode: ele2?.trackCode,
                Track: strTrack,
                RaceInfo : [{
                  goCode: ele2?.goCode,
                  Going  : ele2?.go,
                  Races  : [ele2?.no],
                }]
              })
            }
          });
        }
        setSummaryInfo(Object.assign(summaryInfo, {
          RaceDate,
          StartTime,
          NoOfRace,
          HasStewards: stewardsTemp?.length > 0,
          ChairmanList,
          ChiefList,
          StewardList,
          ResumedJockeys,
          SuspendedJockeys,
          DeferredSuspensionJockey,
          LocalPool,
          BettingPoolOver,
          Penetrometers,
          Hammers,
          VenueCode,
          headDate,
          GoingDetail
        }))
        console.log("BettingPools---", BettingPools, BettingPoolOver, headDate)
        setloading(false)
      }).catch(() => {
        setloading(false)
      })
  }, [])

  const getfilterstewards = (stewardsList:any, roleList:any) => {
    return stewardsList?.filter((i:any) => roleList?.includes(i?.role?.code))?.sort((a:any, b:any) => {
      return a?.sequenceNumber - b?.sequenceNumber
    })?.map((ii:any) => {
      const textRole = t(`LB_${ii?.role?.code?.replaceAll(" ", "")}`);
      return {
        name: lang.langType === "english" ? ii?.name_en + textRole : ii?.name_ch + textRole ,
      }
    })
  }
  const formatDayMonth = (date:string, subtract: boolean = false) => {
    const dateformat = (date:string) => date?.split("/")?.map((i:any) => parseInt(i))?.join('/');
    if (subtract) return dateformat(dayjs(date, "YYYY-MM-DD").subtract(1, 'day').format("DD/MM"));
    return dateformat(dayjs(date, "YYYY-MM-DD").format("DD/MM"));
  }
  const getfilterjkSuspensions = (jkSuspensionsList:any, spsnTyp:any) => {
    const tempSuspensionsList = jkSuspensionsList?.filter((i:any) => i?.spsnTyp == spsnTyp)?.sort((a:any, b:any) => a?.jockeyNms?.[0]?.english?.localeCompare(b?.jockeyNms?.[0]?.english, 'en', {sensitivity: "base"}))
    
    const groupList = _.groupBy(tempSuspensionsList, "jockeyId");
    return Object.keys(groupList).map((key:any) => {
      const jksList = groupList[key];
      let desc = [];
      for (let idx = 0; idx < jksList.length; idx++) { 
        const temptarItem = jksList[idx] as any;
        let desc_item = "";
        if(temptarItem?.mergedRecords?.length) {
          const mergedStr = temptarItem?.mergedRecords?.map((i:any) => {
            return `${i?.desc} (${formatDayMonth(i?.commencedOn)}-${formatDayMonth(i?.resumedOn, true)})`
          })?.join("")
          desc_item = `- ${mergedStr} ${t("Suspensioncommenceson").replace("{0}", dayjs(temptarItem?.commencedOn, "YYYY-MM-DD").format("DD/MM/YYYY"))}${t("mayresumeridingon")?.replace("{0}", dayjs(temptarItem?.resumedOn, "YYYY-MM-DD").format("DD/MM/YYYY"))}`
          desc.push(desc_item);
        } else {
          let desc_item = `- ${lang.langCode == "en-us" ? temptarItem?.desc?.english: temptarItem?.desc?.chinese} ${t("Suspensioncommenceson").replace("{0}", dayjs(temptarItem?.commencedOn, "YYYY-MM-DD").format("DD/MM/YYYY"))}${t("mayresumeridingon")?.replace("{0}", dayjs(temptarItem?.resumedOn, "YYYY-MM-DD").format("DD/MM/YYYY"))}`;
          desc.push(desc_item);
        }
      }
      const tarItem = jksList?.[0] as any;
      const jockeyNm = lang.langType === "english" ? tarItem?.jockeyNms?.[0]?.english : tarItem?.jockeyNms?.[0]?.chinese;
      return {
        jockeyNm: jockeyNm,
        desc: desc,
      }
    });
  }
  const handleTitleDate = (date: string) => lang.langCode == "en-us" ?
  `${new Date(date).getDate().toString().padStart(2, '0')} ${new Date(date).toLocaleString(lang.langCode, { month: "short" })}`
  : `${new Date(date).toLocaleString(lang.langCode, { month: "short" })}${new Date(date).getDate()}日 `;

  const handleRaceHeader = () => {
    return <>
      {
        summaryInfo?.headDate?.map((item:any, idx:any) => {
          const curDate = handleTitleDate(item?.date);
          let btnClass = '';
          if (racedate && regex.test(racedate)) {
            if (racedate.replaceAll("/", "-") == item?.date){
              btnClass = "blueBtn1";
            }else {
              btnClass = "greyBtn";
            }
          } else {
            const simulcastIndex = summaryInfo?.headDate?.findIndex((i:any) => i?.IsLocal)
            if (simulcastIndex == -1) {
              btnClass = idx == 0 ? "blueBtn1": "greyBtn"
            } else {
              if(idx == simulcastIndex) {
                btnClass = "blueBtn1"
              } else {
                btnClass = "greyBtn"
              }
            }
          }
          const hrefUrl = item?.IsLocal ? `/${lang.langCode}/local/info/summary?racedate=${item?.date.replaceAll("-", "/")}`:  `/racing/overseas/${lang.langType}/summary.aspx?para=/${item?.date?.replaceAll("-", "")}/${item?.venueCode}`;
          return <a key={idx} href={hrefUrl} onClick={(event) => {
            if(btnClass =="blueBtn1") event.preventDefault();
          }} className={btnClass}>{curDate} - {item?.country}</a>
        })
      }
    </>
  }
  const renderRaceMeetingDate = () => {
    // Race Meeting: 18/05/2025 (Sun)
    const day = getDayDisplay(summaryInfo?.RaceDate, lang.langCode);
    return `${t("Race_Meeting")}: ${dayjs(summaryInfo?.RaceDate).format("DD/MM/YYYY")}(${day})` 
  }
  const renderRaceMeetingStartTime= () => {
    // 10 races - Meeting Start Time: 12:45
    const race = lang.langCode == "en-us" ? (summaryInfo?.NoOfRace == 1 ? "race" : "races") : "場";
    const date = dayjs(summaryInfo?.StartTime).format("HH:mm");
    return `${summaryInfo?.BettingPoolOver?.length? t("LocalRace") + " - ": ""}${summaryInfo?.NoOfRace} ${race}${lang.langCode == "en-us" ? " - ": " "}${t("LB_MeetingStartTime")}: ${date}`
  }

  const renderGoingInfo = () => {
    const localmeet = summaryInfo?.LocalPool?.[0];
    let track = "";
    let course = "";
    const CourseInfo = [] as any;
    localmeet?.races?.forEach((ele:any) => {
      const itemtrackCode = ele?.raceTrack?.code;
      const itemtrack = lang.langCode == "en-us" ? ele?.raceTrack?.description_en: ele?.raceTrack?.description_ch;
      const itemcourseCode = ele?.raceCourse?.code;
      const itemcourse = lang.langCode == "en-us" ? ele?.raceCourse?.description_en: ele?.raceCourse?.description_ch;
      const targetInfo = CourseInfo?.filter((i:any) =>
      (itemtrackCode !== "AWT" && i?.trackCode === itemtrackCode && i?.courseCode === itemcourseCode ) || 
      (itemtrackCode === "AWT" && i?.trackCode ===itemtrackCode)
      );
      if (!targetInfo?.length) {
        let displaytag = "";
        if (itemtrackCode == "AWT") {
          displaytag = lang.langCode == "en-us" ? itemtrackCode : itemtrack;
        } else {
          displaytag = `${lang.langCode == "en-us" ? capitalizeWords(itemtrack): itemtrack} ${lang.langCode == "en-us" ? toPascalCaseWithSpaces(itemcourse): itemcourse.replaceAll("\"","\'")}`
        }

        CourseInfo.push({
          trackCode: itemtrackCode,
          courseCode: itemcourseCode,
          displaytag,
        })
      }
    });
    course = CourseInfo?.map((i:any) => i?.displaytag)?.join(" / ");
      console.log(666, CourseInfo)
    switch (localmeet?.TrackCode) {
      case "MIXED":
        track = lang.langCode == "en-us" ? 'MIXED': "混合賽道";
        return `${t(localmeet?.Venue)} - ${track} - ${course}`
      
      case "AWT":
        return `${t(localmeet?.Venue)} - ${lang.langCode == "en-us" ? localmeet?.TrackCode : localmeet?.Track}` ;
      default:
        return `${t(localmeet?.Venue)} - ${course}`
    }
   
  }
  return (
   loading ? null: <>
      <div id='mainContainer'>
        <Header />
        <HeaderNav />
        {
          hasData != 1 ? (hasData == 2 ? (<NoInformation type="noinfo" />) : (<NoInformation type="willbeavailable" PageName={t("pagename_GeneralInformation")} DirectPageName={t("pagename_RaceCard")}  pageRemark="GeneralInfo" />)) :
            (
              <div className="commContent jkcStat f_fs13">
                <div style={{ width: "760px" }}>
                  <div className="commTitlePic">
                    <img src={`${assetPrefix}/images/title_ref_general_info_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} />
                  </div>
                  <div className="date_title">
                    <div className="date_title f_tar">
                      { handleRaceHeader()}
                    </div>
                  </div>
                  <div className="data_tab">
                    <div className="data_meeting">
                      <div style={{ fontWeight: "bold" }}>{renderRaceMeetingDate()}</div>
                      <div style={{ fontWeight: "bold" }}>{renderRaceMeetingStartTime()} </div>
                      {
                        summaryInfo?.BettingPoolOver?.map((i:any, idx: any)=> {
                            // 10 races - Meeting Start Time: 12:45
                            const race = lang.langCode == "en-us" ? (i?.totalNumberOfRace == 1 ? "race" : "races") : "場";
                            const date = dayjs(i?.startTime).format("HH:mm");
                          return <div key={idx} style={{ fontWeight: "bold", color: "#096" }}>
                            {`${t("LB_OverSea")} ${i?.Country} - ${i?.totalNumberOfRace} ${race}${lang.langCode == "en-us" ? " - ": " "}${t("LB_MeetingStartTime")}: ${date}`}
                            </div>
                        })
                      }
                    </div>
                    <div className={`data_go ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`}>
                      <p className="data_title">{t("LB_GoingInformation")}</p>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}><a href={`/${lang.langCode}/local/page/racing-course`} className="p2 local">
                              {/* Sha Tin  - MIXED - Turf C+3 Course / AWT  */}
                              {renderGoingInfo()}
                              </a></td>
                          </tr>

                          {
                            summaryInfo?.GoingDetail?.length ? <tr>
                              <td colSpan={3}>
                                  <table>
                                      <tbody><tr>
                                          <td style={{fontSize: "12px", fontWeight: "bold"}}>{t("LB_Going")}:</td>
                                          <td>
                                              <table style={{fontSize: "12px"}}>
                                                <tbody>
                                                  {
                                                    summaryInfo?.GoingDetail?.map((i: any) => {
                                                      return <tr key={i}>
                                                          {
                                                            summaryInfo?.GoingDetail?.length> 1 ? <td className='f_ffxxm'>[{i?.Track}]</td> : null
                                                          }
                                                          {
                                                            i?.RaceInfo?.map((i:any, idx:any) => {
                                                              if (idx > 0) {
                                                                return <>
                                                                <td key={idx}>
                                                                  <img src={`${assetPrefix}/images/general_dir.gif`} style={{border: 0}}/>
                                                                  <span style={{color: "#900"}}>{i?.Going}</span>({t("RaceNoFormat")?.replace("{0}", i?.Races?.join(","))})
                                                                </td>
                                                                </>
                                                              }
                                                              return <td key={idx}>
                                                                <span style={{color: "#900"}}>{i?.Going}</span>({t("RaceNoFormat")?.replace("{0}", i?.Races?.join(","))})</td>
                                                            })
                                                          }
                                                          
                                                      </tr>
                                                    })
                                                  }
                                                </tbody>
                                              </table>
                                          </td>
                                      </tr>
                                  </tbody></table>
                              </td>
                            </tr>: null
                          }
                        
                          {
                            summaryInfo?.Penetrometers?.length ? <tr>
                              <td style={{width: "30%", textAlign: "left"}}><span style={{fontWeight: "bold"}}>{t("LB_PenetrometerReading")}</span></td>
                              <td>
                                {
                                  summaryInfo?.Penetrometers?.map((i:any, idx:any) => {
                                    return <>
                                    <span style={{color: "#900"}}>{i?.reading}</span>{t("LB_ReadingUpdateTime").replace("{0}", formatTime(i?.readingTime))}
                                  {idx != summaryInfo?.Penetrometers?.length - 1 ?<img src={`${assetPrefix}/images/general_dir.gif`} style={{border: 0}}/> : null}
                                  </>
                                  })
                                }
                                
                              </td>
                            </tr> : null
                          }

                          {
                            summaryInfo?.Hammers?.length ? <tr>
                              <td style={{width: "30%", textAlign: "left"}}><span style={{fontWeight: "bold"}}>{t("LB_CleggHammerReading")}</span></td>
                              <td>
                                {
                                  summaryInfo?.Hammers?.map((i:any, idx:any) => {
                                    return <>
                                    <span style={{color: "#900"}}>{i?.reading}</span>{t("LB_ReadingUpdateTime").replace("{0}", formatTime(i?.readingTime))}
                                  {idx != summaryInfo?.Hammers?.length - 1 ?<img src={`${assetPrefix}/images/general_dir.gif`} style={{border: 0}}/> : null}
                                  </>
                                  })
                                }
                                
                              </td>
                            </tr> : null
                          }
                          {
                            GoingReport ? <tr>
                                <td colSpan={2} >
                                    <br/>
                                    <span dangerouslySetInnerHTML={{ __html: GoingReport }}></span>
                                </td>
                            </tr> : null
                          }
                        </tbody>
                        </table>
                    </div>

                    {
                      summaryInfo?.HasStewards ? <div className={`data_Stewards ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`}>
                      <p className="data_title">{t("LB_MeetingStewards")}</p>
                      <table style={{ marginTop: "5px", width: "100%" }} cellSpacing="0">
                        <tbody><tr>
                          <td style={{ width: "33%", padding: "0 5px" }}>
                            <table style={{ width: "100%", marginLeft: "5px" }}>
                              <tbody>
                                {
                                  summaryInfo?.ChairmanList?.map((i:any, idx:any) => {
                                    return  <tr key={idx}>
                                    <td>{i?.name}</td>
                                  </tr>
                                  })
                                }
                              </tbody></table>
                          </td>
                          <td style={{ width: "33%", padding: "0 5px" }}>
                            <table style={{ width: "100%" }}>
                              <tbody>{
                                  summaryInfo?.ChiefList?.map((i:any, idx:any) => {
                                    return  <tr key={idx}>
                                    <td>{i?.name}</td>
                                  </tr>
                                  })
                                }
                              </tbody></table>
                          </td>
                          <td style={{ width: "33%", padding: "0 5px" }}>
                            <table style={{ width: "100%" }}>
                              <tbody>{
                                  summaryInfo?.StewardList?.map((i:any, idx:any) => {
                                    return  <tr key={idx}>
                                    <td>{i?.name}</td>
                                  </tr>
                                  })
                                }
                              </tbody></table>
                          </td>
                        </tr>
                        </tbody></table>
                    </div> : null
                    }
                    
                    <div className={`data_pool ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`} style={{
                      float: "left",
                    }}>
                      <div className="tab">

                        {
                          summaryInfo?.LocalPool?.length ? <>
                          <div className="data_title" style={{ width: "100%" }}>{t("LB_BettingPool")}</div>
                            <div className="tab_left betting">
                              <table>
                                <tbody>
                                  {summaryInfo?.LocalPool?.[0]?.GeneralPoolList?.map((gen:any, idx:any) => {
                                    return <tr key={idx}>
                                      <td style={{ width: "42%" }}>{gen?.PoolName}</td>
                                      <td dangerouslySetInnerHTML={{ __html: gen?.displayLegs }}></td>
                                    </tr>
                                  })}
                                  {summaryInfo?.LocalPool?.[0]?.AllUpPoolList?.map((gen:any, idx:any) => {
                                    return <tr key={idx}>
                                      <td style={{ width: "42%" }}>{gen?.PoolName}</td>
                                      <td dangerouslySetInnerHTML={{ __html: gen?.displayLegs }}></td>
                                    </tr>
                                  })}
                                </tbody>
                                
                                </table>
                            </div>
                            <div className="tab_right betting">
                              <table>
                                <tbody>
                                  {
                                    summaryInfo?.LocalPool?.[0]?.FixedOdds?.length ? <>
                                      <tr>
                                        <td style={{
                                        textAlign: "center",
                                        backgroundColor: "#e6caae"
                                        }}>{t("LB_FIXEDODDSTitle")}</td>
                                      </tr>
                                      {
                                        summaryInfo?.LocalPool?.[0]?.FixedOdds?.map((fo:any, idx: any) => <tr key={idx}>
                                          <td className={(idx + 1)%2 == 0 ? "" : "double_td"}>{fo}</td>
                                      </tr>)
                                      }
                                    </>: null
                                  }

                                  {
                                    summaryInfo?.LocalPool?.[0]?.DoublePoolList?.length ? <>
                                      <tr>
                                        <td style={{ textAlign: "center", backgroundColor: "#e6caae" }}>{t("LB_DBLTitle")}</td>
                                      </tr>
                                      {
                                        summaryInfo?.LocalPool?.[0]?.DoublePoolList?.map((dp:any, idx:any) => <tr key={idx}>
                                            <td className={(idx + 1)%2 == 0 ? "" : "double_td"}>{dp?.PoolName}</td>
                                        </tr>)
                                      }

                                    </> : null
                                  }
                                

                                  {
                                    summaryInfo?.LocalPool?.[0]?.EstDividendList?.length ? <>
                                      <tr>
                                        <td>
                                          <table className="tb_pje">
                                            <tbody><tr className="tr_pje">
                                              <td style={{ width: "42%" }}>{t("LB_Pool")}</td>
                                              <td style={{ width: "29%" }}>{t("LB_jackpot")}</td>
                                              <td style={{ width: "29%" }}>
                                              {t("LB_EstimatedDividend")}
                                              </td>
                                            </tr>
                                            {
                                              summaryInfo?.LocalPool?.[0]?.EstDividendList?.map((est:any, idx:any) => {
                                                return <tr key={idx}>
                                                  <td dangerouslySetInnerHTML={{ __html: est?.PoolName }}></td>
                                                  <td>{est?.Jackpot}</td>
                                                  <td>{est?.RaceNo > 0 ?  "" : est?.Dividend}</td>
                                                </tr>
                                              })
                                              
                                            }
                                            </tbody></table>
                                        </td>
                                      </tr>
                                    </> :null
                                  }
                                  {
                                    Object.keys(summaryInfo?.LocalPool?.[0]?.CFJackpots)?.map((date: any, indx: any) => {
                                      const cFJackpots = summaryInfo?.LocalPool?.[0]?.CFJackpots[date];
                                      const contDay = dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
                                      const title_date = contDay + `(${getDayDisplay(date, lang.langCode)})`;
                                      return <tr key={indx}>
                                      <td>
                                        <table className="tb_pje">
                                          <thead>
                                              <tr className="tr_pje">
                                                  <td colSpan={2} dangerouslySetInnerHTML={{ __html: t("LB_CFJackpotTitle")?.replace("{0}", title_date) }}></td>
                                              </tr>
                                          </thead>
                                          <tbody>
                                          {
                                              cFJackpots?.map((i:any, idx:any) => {
                                                return i?.Jackpot?.map((jackpot:any, idx2:any) => <tr key={idx}>
                                                   {idx2 == 0 && <td rowSpan={i?.Jackpot?.length}style={{ width: "70%", verticalAlign: "middle",}}>{i?.PoolName}</td>}
                                                  <td key={idx}>{jackpot}</td>
                                                  </tr>)
                                              })
                                            }
                                           
                                              {/* <tr><td>{Jackpot}</td></tr> */}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr> 
                                    })
                                  }
                                  
                                </tbody></table>
                            </div>
                          </> : null
                        }
                        
                        <div className="f_clear"></div>
                        
                        {
                          summaryInfo?.BettingPoolOver?.length ? summaryInfo?.BettingPoolOver?.map((poolOver:any, idx:any) => {
                            return <div key={idx} style={{display: "contents"}}>
                            <div className="data_title" style={{ backgroundColor: "green", width: "100%" }}>{t("LB_PoolOverSea")} {poolOver?.Country}
                            </div>
                              <div className="tab_left">
                                <table>
                                  <tbody>
                                  {poolOver?.GeneralPoolList?.map((gen:any, idx:any)=>{
                                      return <tr key={idx}>
                                        <td style={{ width: "42%" }}>{gen?.PoolName}</td>
                                        <td dangerouslySetInnerHTML={{ __html: gen?.displayLegs }}></td>
                                      </tr>
                                  })}

                                  {poolOver?.AllUpPoolList?.map((gen:any, idx:any) => {
                                    return <tr key={idx}>
                                      <td style={{ width: "42%" }}>{gen?.PoolName}</td>
                                      <td dangerouslySetInnerHTML={{ __html: gen?.displayLegs }}></td>
                                    </tr>
                                  })}

                                  </tbody></table>
                              </div>
                              <div className="tab_right betting">
                                <table>
                                  <tbody>
                                    {
                                      poolOver?.FixedOdds?.length ? <>
                                        <tr>
                                          <td style={{
                                          textAlign: "center",
                                          backgroundColor: "#e6caae"
                                          }}>{t("LB_FIXEDODDSTitle")}</td>
                                        </tr>
                                        {
                                          poolOver?.FixedOdds?.map((fo:any, idx: any) => <tr key={idx}>
                                            <td className={(idx + 1)%2 == 0 ? "" : "double_td"}>{fo}</td>
                                        </tr>)
                                        }
                                      </>: null
                                    }

                                    {
                                      poolOver?.DoublePoolList?.length ? <>
                                        <tr>
                                          <td style={{ textAlign: "center", backgroundColor: "#e6caae" }}>{t("LB_DBLTitle")}</td>
                                        </tr>
                                        {
                                          poolOver?.DoublePoolList?.map((dp:any, idx:any) => <tr key={idx}>
                                              <td className={(idx + 1)%2 == 0 ? "" : "double_td"}>{dp?.PoolName}</td>
                                          </tr>)
                                        }

                                      </> : null
                                    }
                                  

                                    {
                                      poolOver?.EstDividendList?.length ? <>
                                        <tr>
                                          <td>
                                            <table className="tb_pje">
                                              <tbody><tr className="tr_pje">
                                                <td style={{ width: "42%" }}>{t("LB_Pool")}</td>
                                                <td style={{ width: "29%" }}>{t("LB_jackpot")}</td>
                                                <td style={{ width: "29%" }}>
                                                {t("LB_EstimatedDividend")}
                                                </td>
                                              </tr>
                                              {
                                                poolOver?.EstDividendList?.map((est:any, idx:any) => {
                                                  return <tr key={idx}>
                                                    <td dangerouslySetInnerHTML={{ __html: est?.PoolName }}></td>
                                                    <td>{est?.Jackpot}</td>
                                                    <td>{est?.RaceNo > 0 ?  "" : est?.Dividend}</td>
                                                  </tr>
                                                })
                                                
                                              }
                                              </tbody></table>
                                          </td>
                                        </tr>
                                      </> :null
                                    }
                                    {
                                    Object.keys(poolOver?.CFJackpots)?.map((date: any, indx: any) => {
                                      const cFJackpots = poolOver?.CFJackpots[date];
                                      const contDay = dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
                                      const title_date = contDay + `(${getDayDisplay(date, lang.langCode)})`;
                                      console.log('00000',cFJackpots)
                                      return <tr key={indx}>
                                      <td>
                                        <table className="tb_pje">
                                          <thead>
                                              <tr className="tr_pje">
                                                  <td colSpan={2} dangerouslySetInnerHTML={{ __html: t("LB_CFJackpotTitle")?.replace("{0}", title_date) }}></td>
                                              </tr>
                                          </thead>
                                          <tbody>
                                            {
                                              cFJackpots?.map((i:any, idx:any) => {
                                                return i?.Jackpot?.map((jackpot:any, idx2:any) => <tr key={idx}>
                                                   {idx2 == 0 && <td rowSpan={i?.Jackpot?.length}style={{ width: "70%", verticalAlign: "middle",}}>{i?.PoolName}</td>}
                                                  <td key={idx}>{jackpot}</td>
                                                  </tr>)
                                              })
                                            }
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr> 
                                    })
                                  }
                                  </tbody>
                                </table>
                              </div>

                              {
                                poolOver?.isOBCommingle ? <>
                                <p style={{float: "left", width: "100%"}}id={"Genrall_PMUNote"} dangerouslySetInnerHTML={{ __html: t('result_france_outbound_PMU_Note') }} />
                                </> : null
                              }
                            </div>
                          }) : null 
                        }

                        {
                          
                        }
                        </div>
                    </div>

                    <div className="f_clear"></div>

                    {
                      summaryInfo?.ResumedJockeys?.length ? <div className="data_pool" style={{ border: "1px solid black" }}>
                      <table style={{ width: "100%" }} className={`tb_csj ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`}>
                        <thead>
                          <tr className="data_title">
                            <td colSpan={2}>{t("LB_ResumedJockeys")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {
                              summaryInfo?.ResumedJockeys?.map((rj:any, idx:any) => {
                              return  <>
                                <tr key={idx}>
                                <td style={{ width: "20%" }}>{rj?.jockeyNm}
                                </td>
                                
                                <td>
                                  {rj?.desc?.map((dec:any, indx: any) => <p key={indx}>{dec}</p>)}
                                </td>
                              </tr>
                              </>
                              })
                          }  
                        </tbody></table>
                    </div>: null
                    }
                    
                    
                    {
                      summaryInfo?.SuspendedJockeys?.length ? <div className="data_pool" style={{ border: "1px solid black" }}>
                      <table style={{ width: "100%" }} className={`tb_csj ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`}>
                        <thead>
                          <tr className="data_title">
                            <td colSpan={2}>{t("LB_Currentlysuspendedjockeys")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {
                              summaryInfo?.SuspendedJockeys?.map((rj:any, idx:any) => {
                              return  <>
                                <tr key={idx}>
                                <td style={{ width: "20%" }}>{rj?.jockeyNm}
                                </td>
                                
                                <td>
                                  {rj?.desc?.map((dec:any, indx: any) => <p key={indx}>{dec}</p>)}
                                </td>
                              </tr>
                              </>
                              })
                          }  
                        </tbody></table>
                    </div>: null
                    }

                    {
                      summaryInfo?.DeferredSuspensionJockey?.length ? <div className="data_pool" style={{ border: "1px solid black" }}>
                      <table style={{ width: "100%" }} className={`tb_csj ${lang.langCode == "zh-hk" ? 'f_ffxxm' : ""}`}>
                        <thead>
                          <tr className="data_title">
                            <td colSpan={2}>{t("LB_Deferredsuspension")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {
                              summaryInfo?.DeferredSuspensionJockey?.map((rj:any, idx:any) => {
                              return  <>
                                <tr key={idx}>
                                <td style={{ width: "20%" }}>{rj?.jockeyNm}
                                </td>
                                
                                <td>
                                  {rj?.desc?.map((dec:any, indx: any) => <p key={indx}>{dec}</p>)}
                                </td>
                              </tr>
                              </>
                              })
                          }  
                        </tbody></table>
                    </div>: null
                    }

                  </div>
                </div>
                <Remarks path="GeneralInfo" customClass="" />
              </div>
            )
        }
      </div>
      <Footer />
    </> 
  );
};
export default Summary;